var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"loader",class:{ cover: _vm.cover }},'div',_vm.$attrs,false),[_c('img',{attrs:{"src":"images/loader.svg"}}),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }